const notifications = {
	title: "Varsler",
	new_notification: "Ny melding",
	edit_notification: "Rediger varsling: {name}",
	view_notification: "Se varsling: {name}",
	list_title: "Liste over varsler",
	create_title: "Opprett varsling",
	update_title: "Oppdater varsling",
	site: "Site",
	header: "Header",
	body: "Body",
	start_date: "Start dato",
	start_time: "Starttid",
	end_date: "Slutt dato",
	end_time: "Slutt tid",
	trigger: "Trigger",
	type: "Type",
	status: "Status",
};
export default notifications;